module.exports = __webpack_public_path__ + "img/play_big.4b147b2d.svg";